import { View } from "react-native";
import { Text } from "react-native-paper";
import { Button, Modal } from "../../components";
import { useSettings } from "../../hooks/useSettings";
import SaveMoneyIcon from "../../svgs/SaveMoney";

export default function QualifiedModal({
  visible,
  onDismiss,
  minimumPointsThreshold,
}: {
  visible: boolean;
  onDismiss(): void;
  minimumPointsThreshold: number;
}) {
  const { setPlanThresholdMet } = useSettings();
  const onCloseModal = () => {
    setPlanThresholdMet();
    onDismiss();
  };

  return (
    <Modal onDismiss={onCloseModal} visible={visible}>
      <View className="p-6 pb-8">
        <View className="flex-row justify-center" testID="qualified-popover">
          <SaveMoneyIcon />
        </View>
        <Text className="text-title-3 text-ink-darkest font-700 text-center mt-4">You have qualified for plan funds.</Text>
        <Text className="text-regular-normal font-400 text-ink-dark mt-3">
          Congratulations! You've reached the {minimumPointsThreshold}-point requirement, which means you're eligible to receive
          a contribution to your retirement account. Keep it up! The more points you earn, the greater the dollar amount of your
          contribution.
        </Text>
        <View className="mt-8">
          <Button mode="secondary" onPress={onCloseModal}>
            Close
          </Button>
        </View>
      </View>
    </Modal>
  );
}
